import { useEffect, useRef } from "react"
import { AnalyticsEventName, AnalyticsEvents } from "~/util/analyticsEvents"
import { trackEvent } from "~/util/tracking"

/**
 * Reports a screen-load event once per mount, as soon as its properties are
 * known. Most list screens carry a result count, so they pass null while the
 * query is still loading and the real properties once it resolves.
 */
export const useTrackScreenEvent = <T extends AnalyticsEventName>(
  eventName: T,
  params: AnalyticsEvents[T] | null
) => {
  const tracked = useRef(false)

  useEffect(() => {
    if (tracked.current || params === null) return
    tracked.current = true
    trackEvent(eventName, params)
  }, [eventName, params])
}
